import { tippy } from '@tippyjs/react';
import Mention from '@tiptap/extension-mention';
import { ReactNodeViewRenderer, ReactRenderer } from '@tiptap/react';

import { RichTextEditorCustomMentionList } from './RichTextEditorCustomMentionList';
import { RichTextEditorCustomMentionPill } from './RichTextEditorCustomMentionPill';

export const RichTextEditorCustomMention = Mention.extend({
  renderHTML({ node, HTMLAttributes }) {
    return ['span', HTMLAttributes, node.attrs.label];
  },
  addNodeView() {
    return ReactNodeViewRenderer(RichTextEditorCustomMentionPill);
  },
  addAttributes() {
    return {
      uuid: {},
      'data-type': {},
      title: {},
      'data-slug': {},
      label: {},
      class: {},
    };
  },
  parseHTML() {
    return [
      {
        tag: 'span.mention',
        getAttrs: (dom) => ({
          id: dom.getAttribute('uuid'),
          label: dom.getAttribute('label'),
          'data-slug': dom.getAttribute('data-slug'),
          'data-type': dom.getAttribute('data-type'),
        }),
      },
    ];
  },
}).configure({
  HTMLAttributes: {
    class: 'mention',
  },
  suggestion: {
    allowSpaces: true,
    allowedPrefixes: [' ', '\n'],
    render: () => {
      let reactRenderer;
      let popup;

      return {
        onStart: (props) => {
          reactRenderer = new ReactRenderer(RichTextEditorCustomMentionList, {
            props,
            editor: props.editor,
          });

          popup = tippy('body', {
            getReferenceClientRect: props.clientRect,
            appendTo: () =>
              document.querySelector('[data-id="resource-modal-container"]') || document.body,
            content: reactRenderer.element,
            showOnCreate: true,
            interactive: true,
            trigger: 'manual',
            placement: 'bottom-start',
            zIndex: 999999999999999,
          });
        },
        onUpdate(props) {
          reactRenderer.updateProps(props);
        },
        onExit(props) {
          popup?.[0]?.destroy();
        },
      };
    },
  },
});
